export default (Vue) => {
  Vue.filter('time', (value) => {
    if (!value) return value

    let time = new Date(value)
    if (value < 60 * 60 * 1000) {
      // Less than one hour
      return time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2)
    } else {
      // Greater or equal one hour
      return time.getUTCHours() + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2)
    }
  })
}



// WEBPACK FOOTER //
// ./src/filters/time.js